<template>
  <div>
    <div class="rp-cart-container rp-modal" :class="{ 'is-active': isActive }">
      <div class="rp-modal-background"></div>
      <div class="rp-modal-content">
        <div class="rp-container-modal">
          <a v-on:click="closeCart" class="close-popup-policy">
            <span class="rp-icon">
                <i class="fa fa-times"></i>
            </span>
          </a>
          <div class="rp-content-modal" id="rp-content-modal">
              <div v-html="defaultPolicy"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { Cart } from '@/store/Cart'

export default {
  name: 'PolicyPopup',
  data () {
    return {
      openCart: false
    }
  },
  computed: {
    defaultPolicy () {
      return Cart.getDefaultPolicy()
    },
    isActive () {
      return this.openCart
    }
  },
  methods: {
    closeCart () {
      this.openCart = false
    }
  },
  mounted () {
    Cart.$on('openPolicyPopup', from => {
      this.openCart = true
    })

    Cart.$on('closeCart', this.closeCart)
  }
}
</script>
<style lang="scss">
.rp-cart-container .rp-modal-content .rp-container-modal .rp-content-modal > div > .popup-policy-container {
  background-color: white;
  font-family: 'sarabun';
  color: black !important;
  padding: 0px;
  line-height: 27px;
  .policy-title h1{
    margin-top: 0px;
  }
  div ul {
    padding-left:25px;
  }
  div h2 {
    color: black !important;
  }
}

</style>
<style lang="scss" scoped>
// @import "~@/scss/custom.scss";

@font-face {
    font-family: 'sarabun';
    font-weight: normal;
    font-style:  normal;
    src: url('~@/fonts/Sarabun-Regular.ttf');
    src: local('sarabun'),
    url('~@/fonts/Sarabun-Regular.eot?#iefix') format('embedded-opentype'),
    url('~@/fonts/Sarabun-Regular.woff') format('woff'),
    url('~@/fonts/Sarabun-Regular.ttf') format('truetype')
}

.rp-cart-container {
  .rp-modal-content {
    max-width: none !important;
    width: 100%;
    height: calc(100vh - 160px);
    max-height: calc(100vh - 160px);
    .rp-container-modal {
      overflow: hidden;
      background-color: white;
      margin: 0 auto;
      height: 100%;
      position: relative;
      .rp-header-modal {
        margin-bottom: 0;
        padding: 15px;
        background-color: #235;
        .rp-page {line-height: 25px;}
      }
      .rp-content-modal {
        background-color: white;
        padding: 1.5em;
        overflow: auto;
        height: calc(100% - 55px);
      }

      a.close-popup-policy {
        color: white !important;
        background-color: black;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        position: absolute;
        right: 5px;
      }
    }
  }
}

.rp-out-of-stock-container {
  .rp-header-modal {
    margin-bottom: 0;
    padding: 10px;
    background-color: #235;

    .rp-page {
      line-height: 25px;
    }
  }

  .rp-modal-content {
    max-width: 320px;

    .rp-content-modal {
      background-color: #efefef;
      padding: 1.5em;
    }
  }
}

@media screen and (max-width: 768px) {
  .rp-cart-container {
    padding: 0;
    .rp-modal-content{
      margin:0;
      background-color: #efefef;
      height: 100%;
      max-height: none;
      .rp-container-modal {
        width: 100%;
      }
    }
  }
}

@media screen and (min-width: 769px) and (max-width: 1023px) {
  .rp-cart-container {
    .rp-container-modal {
      width: 728px;
    }
  }
}

@media screen and (min-width: 1024px){
  .rp-cart-container {
    .rp-container-modal {
      width: 984px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/policyPopup/PolicyPopup.vue